import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { GoogleOAuthProvider } from '@react-oauth/google';

// Google OAuth Client ID - HARDCODED for reliability
const GOOGLE_CLIENT_ID = '414540265690-sbesc1a948bhujqv3qq2o5eqhv01vsug.apps.googleusercontent.com';

console.log('🔐 Google Client ID configured:', GOOGLE_CLIENT_ID.substring(0, 30) + '...');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// PWA disabled — we don't ship a service-worker.js (no Workbox config in
// CRA build), so attempting to register one fetches the SPA-fallback HTML,
// fails with a MIME-type error, AND any stale SW from a previous deploy
// keeps intercepting requests (caused a "START GAME does nothing" outage
// on 2026-05-19). Actively unregister any leftover SW from old deploys.
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
